import { render, staticRenderFns } from "./WrongCodeModal.vue?vue&type=template&id=4de45550"
import script from "./WrongCodeModal.vue?vue&type=script&lang=js"
export * from "./WrongCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports